import React from 'react';
import { Link } from 'react-router-dom';

export default function Button({ children, variant = 'primary', to, onClick, className = '', type = 'button' }) {
  const baseStyle = "inline-flex items-center justify-center px-6 py-3 font-semibold rounded-md transition-all duration-300 shadow-sm";
  
  const variants = {
    primary: "bg-primary text-white hover:bg-blue-900",
    secondary: "bg-secondary text-white hover:bg-blue-600",
    accent: "bg-accent text-white hover:bg-orange-600 shadow-orange-200 shadow-lg",
    outline: "border-2 border-primary text-primary hover:bg-primary hover:text-white"
  };

  const classes = `${baseStyle} ${variants[variant]} ${className}`;

  if (to) {
    return <Link to={to} className={classes}>{children}</Link>;
  }

  return (
    <button type={type} onClick={onClick} className={classes}>
      {children}
    </button>
  );
}